import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import GetLogo from '../../components/GetLogo';
import StyledIcon from '../../../../styledComponents/styles/Icon.styled';
import { AccentButtonMediumOpenSans } from '../../../../styledComponents/styles/Buttons.styled';
import { NavLink } from 'react-router-dom';
import ScreenReaderHeadingComponent from '../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';

const Action = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;

  a {
    color: #373737;
    font-weight: 600;
    text-decoration: underline;
  }
`;

const Header = styled.h1`
  color: #0b3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;

  span {
    font-weight: 600;
  }
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 40px 0 36px 0;
`;

export default function WelcomeSSOForm() {
  const organization = useSelector(state => state.auth.organization);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const email = urlParams.get('email') || '';
  const emailParam = email && email.length > 0 ? `?email=${encodeURIComponent(email)}` : '';
  const [orgName, setOrgName] = useState('');
  const [allowSignup, setAllowSignUp] = useState(true);

  useEffect(() => {
    if (organization && organization.info) {
      setOrgName(organization.org_name);
      setAllowSignUp(organization.info.allow_traveler_sign_up);
    }
  }, [organization]);

  const ssoSignInLink = () => {
    window.location = `${organization.sso_url}`;
  };

  return (
    <>
      <GetLogo />
      <ScreenReaderHeadingComponent text={'Welcome!'} />
      <Header>Welcome!</Header>
      <Instructions>
        {/* Your account is managed through {orgName}. */}
        <span>
          {' '}
          Sign in through {orgName}
          ’s portal.
        </span>
      </Instructions>
      <FormContainer>
        <AccentButtonMediumOpenSans aria-label="Go to Portal" onClick={ssoSignInLink}>
          {'Go to Portal '}
          <StyledIcon type={'ChevronForward'} size={'18px'} />
        </AccentButtonMediumOpenSans>
      </FormContainer>
      {allowSignup && (
        <Action>
          If you do not have a {orgName} login:
          <br />
          <NavLink to={`/traveler/sign_up${emailParam}`}>Sign up</NavLink> or{' '}
          <NavLink to={`/client/non_sso_sign_in${emailParam}`}>Sign In</NavLink>
        </Action>
      )}
      {!allowSignup && (
        <Action>
          If you do not have a {orgName} login:
          <br />
          <NavLink to={`/client/non_sso_sign_in${emailParam}`}>Sign In</NavLink>
        </Action>
      )}
    </>
  );
}
